module.exports = __webpack_public_path__ + "img/qiye.6960bebc.png";